// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "eu-west-1",
    "aws_content_delivery_bucket": "vommarketal-production-hosting",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d1o3voixvx9q09.cloudfront.net",
    "aws_cloud_logic_custom": [
    ]
};


export default awsmobile;
